'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _ButtonStyled = require('./styles/ButtonStyled');

var _ButtonTextStyled = require('./styles/ButtonTextStyled');

var _ButtonTitleStyled = require('./styles/ButtonTitleStyled');

var _ButtonSubtitleStyled = require('./styles/ButtonSubtitleStyled');

var _ButtonIconStyled = require('./styles/ButtonIconStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactackleCore.registerDefaultComponentTheme)('button', _theme2.default);

var propTypes = {
  /** Define button's main text */
  text: _propTypes2.default.string,
  /**
   * Define button's alternate text for the user,
   * if he/she for some reason can't see the component
   */
  alternateTitle: _propTypes2.default.string,
  /** Define button's subtitle */
  subtitle: _propTypes2.default.string,
  /** Define button's size */
  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),
  /** Narrow button has smaller horizontal paddings */
  narrow: _propTypes2.default.bool,
  /** Define button's color */
  colorScheme: _propTypes2.default.oneOf(['primary', 'secondary', 'alert', 'success', 'warning', 'info', 'flat', 'flatLight', 'white', 'link']),
  /** Outlined button has border and transparent background */
  outlined: _propTypes2.default.bool,
  /** Define button's radius */
  radius: _propTypes2.default.oneOf(['none', 'default', 'rounded']),
  /** Raised button has shadow */
  raised: _propTypes2.default.bool,
  /** Set disable to true if interaction with button isn't available to user */
  disabled: _propTypes2.default.bool,
  /** Swap icon and text position */
  iconPositionRight: _propTypes2.default.bool,
  /**
   * Define icon (see IconSvg or IconCustom props)
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * Stop onClick event's propagation and only call onPress
   */
  stopPressPropagation: _propTypes2.default.bool,
  /**
   * Specify function to call on Button press
   */
  onPress: _propTypes2.default.func,
  /**
   * The URL to link to when the button is clicked
   */
  href: _propTypes2.default.string
};

var defaultProps = {
  text: '',
  alternateTitle: '',
  subtitle: '',
  size: 'normal',
  narrow: false,
  colorScheme: 'flat',
  outlined: false,
  radius: 'default',
  raised: false,
  disabled: false,
  iconPositionRight: false,
  icon: null,
  stopPressPropagation: false,
  onPress: _reactackleCore.noop,
  href: ''
};

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this._handleClick = _this._handleClick.bind(_this);
    return _this;
  }

  _createClass(Button, [{
    key: '_handleClick',
    value: function _handleClick(event) {
      if (!this.props.disabled) {
        if (this.props.stopPressPropagation) event.stopPropagation();
        this.props.onPress(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var subtitle = this.props.text && this.props.subtitle ? _react2.default.createElement(
        _ButtonSubtitleStyled.ButtonSubtitleStyled,
        { size: this.props.size },
        this.props.subtitle
      ) : null;

      var buttonText = this.props.text ? _react2.default.createElement(
        _ButtonTextStyled.ButtonTextStyled,
        {
          text: this.props.text,
          subtitle: this.props.subtitle,
          size: this.props.size,
          iconPositionRight: this.props.iconPositionRight
        },
        subtitle,
        _react2.default.createElement(
          _ButtonTitleStyled.ButtonTitleStyled,
          { size: this.props.size },
          this.props.text
        )
      ) : null;

      var iconElement = void 0;

      if (typeof this.props.icon === "function") {
        var Icon = this.props.icon;
        iconElement = _react2.default.createElement(Icon, null);
      } else {
        iconElement = this.props.icon;
      }

      var buttonIcon = this.props.icon ? _react2.default.createElement(
        _ButtonIconStyled.ButtonIconBoxStyled,
        {
          iconPositionRight: this.props.iconPositionRight,
          size: this.props.size,
          disabled: this.props.disabled
        },
        iconElement
      ) : null;

      return _react2.default.createElement(
        _ButtonStyled.ButtonStyled,
        {
          colorScheme: this.props.colorScheme,
          size: this.props.size,
          narrow: this.props.narrow,
          radius: this.props.radius,
          disabled: this.props.disabled,
          outlined: this.props.outlined,
          text: this.props.text,
          title: this.props.alternateTitle,
          subtitle: this.props.subtitle,
          raised: this.props.raised,
          onClick: this._handleClick,
          href: this.props.href
        },
        buttonIcon,
        buttonText
      );
    }
  }]);

  return Button;
}(_react.Component);

exports.default = Button;


Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.displayName = 'Button';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-button/dist/Button.js
// module id = 562
// module chunks = 0